/* global $ Bugsnag */

const env              = require('../env')
const utils            = require('../utils')
const {query, baseurl} = env

const handleError = (userTitle, userMessage, errorText, error) => {
    const $404 = $('.four-oh-four')

    $404.find('h2').text(userTitle)
    $404.find('p').text(userMessage)

    $("#loading-div").fadeOut(400, () => {
        $404.fadeInCss()
    })

    Bugsnag.notifyException(`TokenError: ${errorText}`, error)
}

if (query.t) {
    $.ajax({
        method   : 'GET',
        url      : `${baseurl}/credentials/token/${query.t}`,
        dataType : 'json',
        success  : data => {
            if (data.user) {
                if (data.expired) {
                    return handleError(
                        "That token has expired",
                        "The link we emailed you is only valid for 24 hours. " +
                        "Please return to the credential lander and try again.",
                        "ExpiredToken"
                    )
                }

                if (data.claimed) {
                    return handleError(
                        "That token has already been used",
                        "Your account password has already been set using this link.",
                        "ClaimedToken"
                    )
                }

                $("#loading-div").fadeOut(400, () => {
                    $(".password-reset").fadeInCss()
                })
            } else {
                handleError(
                    "Something went wrong",
                    "We could not connect to our servers, please double check your internet connection and try again.",
                    "No Token Data"
                )
            }
        },

        error : (jqXHR, textStatus, errorThrown) => {
            if (jqXHR.status === 404) {
                return handleError(
                    "Invalid token",
                    "We could not find that token. Please ensure you copied the link emailed to you correctly.",
                    textStatus,
                    errorThrown
                )
            }

            handleError(
                "Something went wrong",
                "We could not connect to our servers, please double check your internet connection and try again.",
                textStatus,
                errorThrown
            )
        }
    })

    $("#password-reset-form").submit(e => {
        e.preventDefault()

        if (utils.busy) {
            return
        }

        const password = $("#password").val()

        if (password.length === 0) {
            return utils.showErrorMessage("Please enter a password")
        }

        utils.hideMessages()
        utils.showLoadingState()

        // Get the details relating to the token
        $.ajax({
            method      : 'POST',
            url         : $('body').hasAttr('data-generic') ? `${baseurl}/credentials/generic/token/${query.t}` :
                `${baseurl}/password/reset/${query.t}`,
            data        : JSON.stringify({
                password
            }),
            dataType    : 'json',
            contentType : 'text/plain',
            success     : data => {
                if (data.success) {
                    if (data.email) {
                        $("#reset-success-copy").text(`You can now log into your Names & Faces app using ${data.email} along with your newly created password.`)
                    }

                    $(".password-reset").fadeOut(700, () => {
                        $(".reset-success, footer").fadeInCss()
                    })
                } else {
                    utils.hideLoadingState()

                    return utils.showErrorMessage(data.errors && data.errors.length && data.errors[0].message ||
                        "There was an issue processing your request. " +
                        "Please contact us at hello@namesandfaces.co."
                    )
                }
            },

            error : (jqXHR, textStatus, errorThrown) => {
                utils.hideLoadingState()

                if (jqXHR.responseJSON && jqXHR.responseJSON.errors && jqXHR.responseJSON.errors.length) {
                    return utils.showErrorMessage(
                        jqXHR.responseJSON.errors[0].message
                    )
                }

                return utils.showErrorMessage(
                    "There was an issue processing your request. " +
                    "Please contact us at hello@namesandfaces.co."
                )
            }
        })
    })
} else {
    // Show base form
    $("#loading-div").fadeOut(400, () => {
        $(".password-send-email").fadeInCss()
    })

    $("#password-send-email-form").submit(e => {
        e.preventDefault()

        if (utils.busy) {
            return
        }

        const email = $("#email").val()

        if (email.length === 0) {
            return utils.showErrorMessage("Please enter an email address")
        }

        utils.hideMessages()
        utils.showLoadingState()

        // Get the details relating to the token
        $.ajax({
            method      : 'POST',
            url         : `${baseurl}/password/email`,
            data        : JSON.stringify({
                email
            }),
            dataType    : 'json',
            contentType : 'text/plain',
            success     : data => {
                if (data.success) {
                    utils.showSuccessMessage("We’ve sent you an email with a link to reset your password ")
                } else {
                    return utils.showErrorMessage(
                        "There was an issue processing your request. " +
                        "Please contact us at hello@namesandfaces.co."
                    )
                }
            },

            error : (jqXHR, textStatus, errorThrown) => {
                if (jqXHR.responseJSON && jqXHR.responseJSON.errors && jqXHR.responseJSON.errors.length) {
                    return utils.showErrorMessage(
                        jqXHR.responseJSON.errors[0].message
                    )
                }

                return utils.showErrorMessage(
                    "There was an issue processing your request. " +
                    "Please contact us at hello@namesandfaces.co."
                )
            },

            complete : () => {
                utils.hideLoadingState()
            }
        })
    })
}



/** WEBPACK FOOTER **
 ** ./js/credentials/routes/passwordReset.js
 **/